import { gql } from "@apollo/client";

export const GET_RECENT_CHANGES = gql`
  query GetRecentChanges(
    $salonId: String!
    $limit: Float!
    $tableNames: [String!]
    $userId: String
    $entityId: String
    $startDate: String
    $endDate: String
  ) {
    getRecentChanges(
      salonId: $salonId
      limit: $limit
      tableNames: $tableNames
      userId: $userId
      entityId: $entityId
      startDate: $startDate
      endDate: $endDate
    ) {
      entries {
        id
        tableName
        entityId
        operation
        timestamp
        changes {
          field
          oldValue
          newValue
          prismaType
          enumValues
          isRelation
          relatedModel
          fieldKind
        }
        user {
          id
          fullName
          email
        }
        metadata
        ipAddress
      }
      totalCount
    }
  }
`;

export const GET_SERVICE_RELATED_CHANGES = gql`
  query GetServiceRelatedChanges(
    $salonId: String!
    $limit: Float!
    $startDate: String
    $endDate: String
  ) {
    getServiceRelatedChanges(
      salonId: $salonId
      limit: $limit
      startDate: $startDate
      endDate: $endDate
    ) {
      entries {
        id
        tableName
        entityId
        operation
        timestamp
        changes {
          field
          oldValue
          newValue
          prismaType
          enumValues
          isRelation
          relatedModel
          fieldKind
        }
        user {
          id
          fullName
          email
        }
        metadata
        ipAddress
      }
      totalCount
    }
  }
`;

export const GET_PRICE_CHANGES = gql`
  query GetPriceChanges(
    $salonId: String!
    $limit: Float!
    $startDate: String
    $endDate: String
  ) {
    getPriceChanges(
      salonId: $salonId
      limit: $limit
      startDate: $startDate
      endDate: $endDate
    ) {
      entries {
        id
        tableName
        entityId
        operation
        timestamp
        changes {
          field
          oldValue
          newValue
          prismaType
          enumValues
          isRelation
          relatedModel
          fieldKind
        }
        user {
          id
          fullName
          email
        }
        metadata
        ipAddress
      }
      totalCount
    }
  }
`;
